import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { userApi, apiError } from "@/lib/userApi";
import { useUserAuth } from "@/context/UserAuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { CircuitBg } from "@/components/CircuitBg";
import { playForgeGate } from "@/components/ForgeGate";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { signIn } = useUserAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await userApi.post("/user/auth/google/session", { session_id: sessionId });
        signIn(data.user);
        const ref = localStorage.getItem("df_ref");
        if (ref) {
          try { await userApi.post("/user/referral-claim", { code: ref }); } catch (e) { /* no bloquea */ }
          localStorage.removeItem("df_ref");
        }
        await playForgeGate({
          title: `BIENVENIDO${data.user?.name ? `, ${data.user.name.toUpperCase()}` : ""}`,
          subtitle: "A LA COMUNIDAD DE DIGITAL FORGE",
        });
        window.history.replaceState(null, "", "/muro");
        navigate("/muro", { replace: true });
      } catch (e) {
        toast.error(apiError(e, "No se pudo entrar con Google"));
        navigate("/acceso", { replace: true });
      }
    })();
  }, [location.hash, navigate, signIn]);

  return (
    <div className="min-h-screen flex items-center justify-center circuit-bg theme-noir" style={{ backgroundColor: "#05070C" }}>
      <CircuitBg />
      <div className="circuit-veil" aria-hidden="true" />
      <div className="glass-card px-8 py-6 flex items-center gap-3 text-white/80" data-testid="auth-callback">
        <Loader2 className="w-5 h-5 animate-spin text-red-400" /> Entrando…
      </div>
    </div>
  );
}
